import * as types from "./mutation-type";

export default {
    [types.SET_IMAGES](state, payload) {
        state.images = payload;
    }
};
